import { updateNotification } from "./utils/updateNotification";
import { events } from "@planzone/events";
import { createStateReducer } from "../utils/createStateReducer";
import { initialState } from "./initialState";

const reduceUpdateOrganizationalUnitState = createStateReducer(initialState, {
  [events.updateOrganizationalUnitSucceeded]: (state) => ({
    ...state,
    queue: updateNotification(
      {
        key: "updateOrganizationalUnit",
        flags: ["success"],
        args: { success: "true" },
      },
      state.queue,
    ),
  }),
  [events.updateOrganizationalUnitFailed]: (state) => ({
    ...state,
    queue: updateNotification(
      {
        key: "updateOrganizationalUnit",
        flags: ["failure"],
        args: { failure: "true" },
      },
      state.queue,
    ),
  }),
});

export { reduceUpdateOrganizationalUnitState };
